import { render, staticRenderFns } from "./Hypertension.vue?vue&type=template&id=0a81c46c&scoped=true&"
import script from "./Hypertension.vue?vue&type=script&lang=js&"
export * from "./Hypertension.vue?vue&type=script&lang=js&"
import style0 from "./Hypertension.vue?vue&type=style&index=0&id=0a81c46c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a81c46c",
  null
  
)

export default component.exports